<template>
  <div class="wrapper">
    <input type="checkbox" :id="props.id" :value="modelValue" @input="onInput">
    <div class="wrapper__content">
      <Label :id="props.id" :required="props.required">
          <slot></slot>
      </Label>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    </div>
  </div>
</template>
<style scoped>
.wrapper {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: var(--gap-xs);
}
input {
  width: 1.6rem;
  height: 1.6rem;
}
.error-message {
  color: var(--color-danger-500);
}
</style>

<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
  },
  id: {
    type: String,
    required: true
  },
  required: {
    type: Boolean,
    default: false
  },
  error: {
    type: String,
  }
})

const errorMessage = ref('')

watch(() => props.error, (value) => {
  errorMessage.value = value
})

const onInput = (event) => {
  errorMessage.value = '' // reset error message
  emits('update:modelValue', event.target.value) // update value
}
const emits = defineEmits(['update:modelValue'])
</script>